import { useContext, useEffect, useState } from "react";
import GuarantorIdStep from "../../components/Tenant/Guarantor/GuarantorIdStep";
import GuarantorDocsStep from "../../components/Tenant/Guarantor/GuarantorDocsStep";
import useTranslator from "../../hooks/useTranslator";
import { Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import TenantContext from "../../context/tenant/TenantContext";
import AuthContext from "../../context/auth/AuthContext";
import { useSnackbar } from "material-ui-snackbar-provider";
import { sendUniversalMail } from "../../services/sharedService";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap/esm";
import { haveValue } from "../../helper/common";

const GuarantorTasks = () => {
  const navigate = useNavigate();
  const { _t } = useTranslator();
  const { user } = useContext(AuthContext);
  const queryParameters = new URLSearchParams(window.location.search);
  const guarantor_id = queryParameters.get("guarantor_id");
  const { getGuarantorDetailsWithEmail, guarantorAddedDetails } =
    useContext(TenantContext);
  const [guarantorData, setGuarantorData] = useState({});

  const snackbar = useSnackbar();
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const createGuarantor = () => {
    sendMail(guarantorData?.email, "score");
  };

  const sendMail = (receiverEmail, emailType) => {
    setButtonDisabled(true);
    let payload = {
      receiverEmail: receiverEmail,
      senderId: user?._id,
      emailType: emailType,
    };
    sendUniversalMail(payload)
      .then((res) => {
        setButtonDisabled(false);
        snackbar.showMessage(_t("emailSent"));
        navigate("/tenant");
        console.log(res);
      })
      .catch((err) => {
        setButtonDisabled(false);
        snackbar.showMessage(_t("errorSendingMail"), err?.message);
        console.log(err);
      });
  };

  useEffect(() => {
    if (haveValue(guarantor_id)) {
      guarantorAddedDetails(guarantor_id)
        .then((res) => {
          loadGuarantorData(res.success_res?.gurantor_email);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      loadGuarantorData();
    }
  }, []);

  const loadGuarantorData = (email = null) => {
    getGuarantorDetailsWithEmail(email)
      .then((res) => {
        console.log(res, "akjshdkjasdhjkashd");
        setGuarantorData(res.guarantorData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleNavigateHome = () => {
    navigate("/tenant/connectBank");
  };

  return (
    <>
      <div className="step-form-main-wrapper">
        <div className="d-flex step-absolute-header step-form-header">
          <Container className="p-0 text-center back-btn ">
            <div className="">
              <a href={undefined} onClick={handleNavigateHome}>
                <img src="/images/back-btn-white.svg" alt="" />
              </a>
            </div>
          </Container>
          <h3 class="step-form-name">
            <img src="/images/profile-icon.svg" alt="" />
            <span>{_t("completeGuanratorDetailsAndSubmit")}</span>
          </h3>
        </div>
        <div className="custom-container container">
          <Row className="d-flex green-strip">
            <Col xl={4} className="gurantor-icon-name">
              <img
                className="gurantor-icon"
                src="/images/lightProfile-icon.svg"
                alt=""
              />
              <p className="gurantor-name">
                {guarantorData?.fname ?? ""} {guarantorData?.lname ?? ""}
              </p>
            </Col>
            <Col xl={4}>
              <label className="green-strip-heading">
                {_t("guarantorEmail")}
              </label>
              <p className="green-strip-desc">{guarantorData?.email}</p>
            </Col>
            <Col xl={4}>
              <label className="green-strip-heading">
                {_t("relationshipWithGuarantor")}
              </label>
              <p className="green-strip-desc">{_t(user?.gurantor_relation)}</p>
            </Col>
          </Row>
          <div>
            <h4 className="step-name text-start mt-4">
              {_t("guaratorProfileStep")}
            </h4>
            <GuarantorIdStep
              guarantorData={guarantorData}
              loadGuarantorData={loadGuarantorData}
            />
            <GuarantorDocsStep guarantorData={guarantorData} />
            <div className="d-flex justify-content-center">
              <button
                className="btn btngreen"
                onClick={createGuarantor}
                disabled={buttonDisabled}
              >
                {_t("createGuarantor")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default GuarantorTasks;
